import { css } from '@emotion/core'
import styled from '@emotion/styled'

import { transientOptions } from '../../constants/transientOptions'
import { Spacing } from '../../enums/spacing'

export type Direction = 'row' | 'column'

interface ComponentsGroupItemProps {
  fitToWidth?: boolean
}

export const ComponentsGroupItem = styled.li<ComponentsGroupItemProps>`
  ${({ fitToWidth }) =>
    fitToWidth &&
    css`
      flex: 1;
    `}
`

interface ComponentsGroupListProps {
  centered?: boolean
  direction: Direction
  spacing?: Spacing
  $wrap?: boolean
}

export const ComponentsGroupList = styled('ul', transientOptions)<ComponentsGroupListProps>`
  display: flex;
  align-items: ${({ centered, direction }) => (centered && direction === 'row' ? 'center' : 'unset')};
  flex-direction: ${({ direction }) => direction};
  flex-wrap: ${({ $wrap }) => ($wrap ? 'wrap' : 'unset')};
  row-gap: ${({ direction, spacing, $wrap }) => (direction === 'column' || $wrap ? spacing : 'unset')};
  column-gap: ${({ direction, spacing }) => (direction === 'row' ? spacing : 'unset')};

  justify-content: ${({ centered, direction }) => (centered && direction === 'column' ? 'center' : 'unset')};
`
